import { fromZonedTime, toZonedTime } from "date-fns-tz";

const timeZoneAU = 'Australia/Sydney';

export function ConvertToAUDateTimeUTC(dateTime: Date): Date {
    return fromZonedTime(dateTime, timeZoneAU);
}

export function ConvertToDateTimeAu(dateTime: Date): Date {
    return toZonedTime(dateTime, timeZoneAU);
}
